import { PreviousExhibitsDropdown } from 'components/ExhibitsExport/PreviousExhibitsDropdown';
import { DivWithLoader } from 'components/UIComponents/DivWithLoader/DivWithLoader';
import './ExhibitExportPanel.css';

type Props = React.PropsWithChildren<{
  title: string;
  showHistory?: boolean;
  historyElement?: React.ReactElement;
  loading?: boolean;
  onShowHistoryClick: () => void;
}>;

export const ExhibitExportPanel = ({
  title,
  showHistory,
  historyElement,
  children,
  loading,
  onShowHistoryClick,
}: Props) => {
  return (
    <DivWithLoader loading={loading} className="exhibit-exporter-panel__container">
      <div className="exhibit-exporter-panel">
        <header>
          <div className="exhibit-exporter-panel__top">
            <div className="exhibit-exporter-panel__title">{title}</div>
            <div className="exhibit-exporter-panel__right-side">
              <PreviousExhibitsDropdown toggleExhibitHistory={onShowHistoryClick} />
            </div>
          </div>
          {showHistory && historyElement}
        </header>
        <section>{children}</section>
      </div>
    </DivWithLoader>
  );
};
